import React, { useEffect, useState } from 'react'
import { FormProvider, useForm, useWatch } from 'react-hook-form'
import { useSelector } from 'react-redux'

import {
  Button,
  Flex,
  HStack,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
} from '@chakra-ui/react'

import { DummyInput, Input, Select } from '@/components/Form'

import useUser from '@/features/users/useUser'

import { authSelector } from '@/stores/auth/authSlice'
import { toast } from 'react-toastify'

//Constant
import { useApplicationType } from '@/features/applicationTypes/useApplicationType'
import { SystemVariableType } from '@/features/systemVariables/constants'
import useSystemVariable from '@/features/systemVariables/useSystemVariable'
import { createOptions } from '@/utils/arrayHelper'
import { useApplication } from '../../useApplication'

const ApplicationDetailModal = ({ modalDetail, setModalDetail }) => {
  const { show, isCreate, detail } = modalDetail
  const { user } = useSelector(authSelector)

  const [firstApproverType, setFirstApproverType] = useState('')
  const [referenceLabel, setReferenceLabel] = useState('Reference')

  // Hook
  const { useFetchAllUsers } = useUser()
  const { useCreateApplication, useUpdateApplication } = useApplication()
  const { useApplicationTypeOptions } = useApplicationType()
  const { useSystemVariableOptions } = useSystemVariable()

  const { data: fetchUsersResponse } = useFetchAllUsers({
    page: 1,
    pageSize: 0,
    sortBy: 'fullName',
    orderBy: 1,
    filters: { status: 'active' },
  })

  const addApplication = useCreateApplication()
  const updateApplication = useUpdateApplication()
  const methods = useForm({ defaultValues: detail })

  const category = useWatch({ name: 'category', control: methods.control })
  const typeId = useWatch({ name: 'type', control: methods.control })

  //Transformed Variables
  //TODO: TEST
  const { data: applicationCategoryOptions } = useSystemVariableOptions(SystemVariableType.APPLICATION_CATEGORY, {
    status: 'active',
  })
  const { data: applicationTypeOptions } = useApplicationTypeOptions({ category: category })

  const userOptions = createOptions(fetchUsersResponse?.data, 'fullName', '_id', true)

  useEffect(() => {
    if (detail && user?._id) {
      methods.reset(detail)

      methods.setValue('applicant', user._id)
    }
  }, [detail, user?._id, methods])

  // useEffect(() => {
  //   if (applicationTypeResponse?.data && typeId) {
  //     // Filter Application Type Option
  //     const selectedTypeDetail = applicationTypeResponse.data.find((typeDetail) => typeDetail.id === typeId)

  //     if (selectedTypeDetail) {
  //       setFirstApproverType(selectedTypeDetail?.firstApproverType || '')
  //       setReferenceLabel(selectedTypeDetail?.referenceLabel || 'Reference')
  //     }
  //   }
  // }, [applicationTypeResponse?.data, typeId])

  // Handler

  const closeModal = () => {
    setModalDetail({
      show: false,
      isCreate: true,
      detail: {},
    })
  }
  const onSubmit = (data) => {
    if (isCreate) {
      addApplication.mutate(data, {
        onSuccess: () => {
          closeModal()
        },
      })
    } else {
      const { id } = detail

      if (!id) {
        return
      }

      updateApplication.mutate(
        { id, data },
        {
          onSuccess: () => {
            closeModal()
          },
        },
        {
          onError: (err) => {
            toast.error(err)
          },
        }
      )
    }
  }

  return (
    <Modal isOpen={show} onClose={closeModal}>
      <ModalOverlay />
      <ModalContent maxW={'40%'}>
        <FormProvider {...methods}>
          <form onSubmit={methods.handleSubmit(onSubmit)}>
            <ModalHeader>{isCreate ? 'Create' : 'Update'} Application</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
              <Flex gap={3} direction={'column'}>
                <Select
                  name="category"
                  label="Category"
                  placeholder="Enter value"
                  options={applicationCategoryOptions}
                  isRow
                />
                <Select name="type" label="Type" placeholder="Enter value" options={applicationTypeOptions} isRow />
                <Input name="reference" label={referenceLabel} type="text" placeholder="Enter value" isRow />

                <DummyInput label="Applicant" isRow value={user?.fullName || "'"} />
                <Input name="nameOfHolder" label="Name Of Holder" type="text" placeholder="Enter value" isRow />
                {firstApproverType === 'lineManager' && (
                  <Select
                    name="lineManager"
                    label="Line Manager"
                    placeholder="Enter value"
                    options={userOptions}
                    isRow
                  />
                )}
              </Flex>
            </ModalBody>

            <ModalFooter>
              <HStack>
                <Button colorScheme="green" type="submit">
                  {isCreate ? 'Add' : 'Update'}
                </Button>

                <Button colorScheme="gray" onClick={closeModal}>
                  Close
                </Button>
              </HStack>
            </ModalFooter>
          </form>
        </FormProvider>
      </ModalContent>
    </Modal>
  )
}

export default ApplicationDetailModal
